import Hero, { HeroType } from "../../components/hero/hero.component"
import eventImage from "../../assets/images/table_mountain.jpg"
import "./eventDetails.styles.scss";
import Button, { BUTTON_TYPE_CLASSES } from "../../components/button/button.component";
import EventCard from "../../components/eventCard/eventCard.component"
import Footer from "../../components/footer/footer.component"
import { useEffect, useState } from "react"
import EventDescription, { DESCRIPTION_TYPE } from "../../components/eventDescription/eventDescription.component"
import { useParams } from "react-router-dom"
import { useFetchAdventure, useFetchAdventureImages } from "../../api/queries/adventureQueries"
import moment from "moment"

const EventDetails = () => {
    const [ destinationPhoto, setDestinationPhoto ] = useState(eventImage);
    const [ activePhoto, setActivePhoto ] = useState(0);
    const [ activeItem, setActiveItem ] = useState(1);
    const [ descriptionType, setDescriptionType ] = useState(DESCRIPTION_TYPE.base);
    const { id } = useParams();

    const { data: adventure } = useFetchAdventure(id);
    const { data: images } = useFetchAdventureImages(id);
    
    const handlePreviewClick = (image, index) => {
        setDestinationPhoto(image)
        setActivePhoto(index)
    }

    const handleDescriptionClick = (type, index) => {
        setDescriptionType(type)
        setActiveItem(index)
    }

    useEffect(() => {
        setActivePhoto(images[0]?.id);
        setDestinationPhoto(images[0]?.image)
    }, [images]);

    return <>
        <Hero
            headerPrimary={adventure?.name}
            headerSecondary={`Max Elevation ${adventure?.maxElevation}`}
            heroType={HeroType.DetailPage}
            backgroundImage={`data:image/unknown;base64,${adventure?.displayImage}`}
            noNavigation
        />
        <div className="event-details">
            <div className="event-details__summary u-margin-bottom-small">
                <div className="event-photos">
                    <div className="event-photos__list">
                        {
                            images?.map((image) => (
                                <div 
                                    key={image.id}
                                    className={activePhoto === image.id ? 'event-photos__list-preview event-photos__list-preview--highlighted' : 'event-photos__list-preview'} 
                                    onClick= {() => handlePreviewClick(image.image, image.id)}
                                >
                                    <img src={`${image.image}`} alt="event"></img>
                                </div>
                            ))
                        }
                    </div>
                    <div className="event-photos__view">
                        <img src={`${destinationPhoto}`}  alt="event"></img>
                    </div>
                </div>
                <div className="event-details__summary-content">
                    <p className="event-card__tags">
                        {
                            adventure?.isChildFriendly ? <span className="event-card__tag">child friendly</span> : ""
                        }
                        <span className="event-card__tag">{adventure?.difficulty}</span>
                        <span className="event-card__tag">{adventure?.type}</span>
                    </p>
                    <h2 className="header__tertiary--main header__tertiary--black">{adventure?.name}</h2>
                    <p className="event-card__date u-margin-bottom-tiny"><b>Event Date:</b> {moment(adventure?.startDate).format("MMMM DD, YYYY")}</p>
                    <ul className="event-details__summary-list">
                        <li><b>Duration:</b> {adventure?.duration}</li>
                        <li><b>Difficulty:</b> {adventure?.difficulty}</li>
                        <li><b>Distance(kms):</b> {adventure?.distanceInKm}</li>
                        <li><b>Child Friendly:</b> {adventure?.isChildFriendly ? "Yes" : "No"}</li>
                        <li><b>Elevation Gain:</b> {adventure?.maxElevation}</li>
                        <li><b>Elavation Loss:</b> {adventure?.elevationGain}</li>
                    </ul>
                    <div className="event-details__button">
                        <Button buttonType={BUTTON_TYPE_CLASSES.eventButton} buttonclassName="btn__blue">Register Now</Button>
                        <Button buttonType={BUTTON_TYPE_CLASSES.eventButton} buttonclassName="btn__white">Contact Us</Button>
                    </div>
                </div>
            </div>
            <div className="event-details__description u-margin-bottom-medium">
                <div className="event-details__description-header u-margin-bottom-small">
                    <ul>
                        <li 
                            className={activeItem === 1 ? 'event-details__description-header--highlighted' : ''}
                            onClick= {() => handleDescriptionClick(DESCRIPTION_TYPE.base, 1)}
                        >
                            Hike Details
                        </li>
                        <li 
                            className={activeItem === 2 ? 'event-details__description-header--highlighted' : ''}
                            onClick= {() => handleDescriptionClick(DESCRIPTION_TYPE.price, 2)}
                        >
                            Pricing
                        </li>
                    </ul>
                </div>
                <div className="event-details__description-content">
                    <EventDescription type={descriptionType} adventure={adventure}/>
                </div>
            </div>
            <div className="event-details__hikes u-margin-bottom-medium">
                <h2 className="header__secondary--sub u-text-align-centre u-margin-bottom-small">Related Hikes</h2>
                <div className="event-details__hikes-list">
                    <div className="events-details__hike">
                        <EventCard link="/events/details"/>
                    </div>
                    <div className="events-details__hike">
                        <EventCard link="/events/details"/>
                    </div>
                    <div className="events-details__hike">
                        <EventCard link="/events/details"/>
                    </div>
                </div>
            </div>
        </div>
        <div className="u-footer-height">
            <Footer/>
        </div>
    </>
}

export default EventDetails;

